import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the InitWizardProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class InitWizardProvider {

  question1: number;
  question2: number = 0;
  stepCounterEngine: string;
  moodTracking: boolean = true;
  backpainTracking: boolean = false;
  backpainLevel: number;


}



// WEBPACK FOOTER //
// ./src/providers/init-wizard/init-wizard.ts